import React, { ReactElement, ReactNode } from 'react';
import { Spinner } from 'react-bootstrap';

export interface Props {
  loading: boolean;
  /**
   * If set true, the children are always mounted, but styled to be hidden when loading
   */
  mounted?: boolean;
  children: ReactNode;
}

const ContentLoading = ({ loading, mounted, children }: Props): ReactElement => {
  if (mounted) {
    return (
      <>
        {loading && <Spinner animation="border" />}
        <div className={loading ? 'loader loading' : 'loader'}>{children}</div>
      </>
    );
  }
  if (loading) return <Spinner animation="border" />;

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default ContentLoading;
